import { create } from 'zustand';

interface TaskFormStore {
    is_valid: boolean;
    is_submitting: boolean;
    clearForm: () => void;
}

export const useTaskFormStore = create<TaskFormStore>((set) => ({
    is_valid: false,
    is_submitting: false,
    clearForm: (): void => set({ is_valid: false }),
}));
